<template>
    <div>
        <div v-if="gamesStore[type].ready && providerStore.ready">
            <div class="mt-5 flex items-center" :class="showCategoryBtn ? 'justify-between' : 'justify-end'">
                <div v-if="showCategoryBtn" class="inline-flex items-center border-[1px] rounded-[30px] px-[20px] py-[10px] cat-btn-container">
                    <button @click="selectedCategoryFunction(1)" :aria-label="$t('all_games')" type="button" class="category_btn mr-5" :class="selectedCategory == 1 ? 'active' : ''">
                        <Icon v-if="config.public?.IS_NEW_ICON || [1].includes(config.public?.TMPL_TYPE)" iconClass="icon-promo-all mr-2"></Icon>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                            <g id="icon" transform="translate(-5.4 -9.5)">
                                <path id="Path_90618" data-name="Path 90618" d="M44.9,31.978a.789.789,0,1,0-.8-.789A.819.819,0,0,0,44.9,31.978Z" transform="translate(-20.48 -10.375)"/>
                                <path id="Path_90619" data-name="Path 90619" d="M26.727,12.564v-.975A2.1,2.1,0,0,0,24.608,9.5H22.866a2.1,2.1,0,0,0-2.119,2.089v.7h-5.7v-.7A2.1,2.1,0,0,0,12.933,9.5H11.191a2.1,2.1,0,0,0-2.119,2.089v.975A5.379,5.379,0,0,0,5.4,17.671v11.49A5.378,5.378,0,0,0,10.814,34.5c2.166,0,3.908-3.373,3.908-5.508a.2.2,0,0,1,.188-.186h5.979a.2.2,0,0,1,.188.186c0,2.136,1.742,5.508,3.908,5.508A5.377,5.377,0,0,0,30.4,29.161V17.671a5.319,5.319,0,0,0-3.672-5.107Zm-7.3,9.457H16.416a.938.938,0,0,1-.942-.928.97.97,0,0,1,.942-.928H19.43a.938.938,0,0,1,.942.928A.909.909,0,0,1,19.43,22.021Zm-6.214,0h-.8v.836a.938.938,0,0,1-.942.928.969.969,0,0,1-.942-.928v-.789H9.684a.938.938,0,0,1-.942-.928.97.97,0,0,1,.942-.928h.8v-.836a.938.938,0,0,1,.942-.928.969.969,0,0,1,.942.928v.789h.847a.938.938,0,0,1,.942.928.909.909,0,0,1-.942.928Zm11.2-3.9a2.646,2.646,0,1,1,0,5.292,2.646,2.646,0,1,1,0-5.292Zm-1.742-6.532a.221.221,0,0,1,.235-.232h1.742a.221.221,0,0,1,.235.232v.7H22.678ZM11,11.589a.221.221,0,0,1,.235-.232H12.98a.221.221,0,0,1,.235.232v.7H11Z" transform="translate(0)"/>
                            </g>
                        </svg>
                        <div class="text">{{$t("all_games")}}</div>
                    </button>
                    <button @click="selectedCategoryFunction(2)" :aria-label="$t('hot_games')" type="button" class="category_btn mr-5" :class="selectedCategory == 2 ? 'active' : ''">
                        <Icon v-if="config.public?.IS_NEW_ICON" iconClass="icon-hot m-2"></Icon>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                            <g id="hotgame" transform="translate(-717 -1452)">
                                <rect id="Rectangle_12155" data-name="Rectangle 12155" width="25" height="25" transform="translate(717 1452)" fill="none"/>
                                <path id="fire" d="M73.954,0c-5.328,3.07-4.687,11.719-4.687,11.719s-2.344-.781-2.344-4.3a9.526,9.526,0,0,0-4.688,8.2,9.375,9.375,0,0,0,18.75,0c0-7.617-7.031-9.18-7.031-15.625Zm-1.52,21.77a3.516,3.516,0,0,1-1.7-6.822c4.548-1.134,5.118-3.692,5.118-3.692S78.119,20.352,72.434,21.77Z" transform="translate(657.89 1452)"/>
                            </g>
                        </svg>
                        <div class="text">{{$t("hot_games")}}</div>
                    </button>
                    <button :aria-label="$t('favourite_games')" @click="selectedCategoryFunction(4)" type="button" class="category_btn mr-5" :class="selectedCategory == 4 ? 'active' : ''">
                        <Icon v-if="config.public?.IS_NEW_ICON" iconClass="icon-special m-2"></Icon>
                        <Icon v-else iconClass="icon-favourite category_btn"></Icon>
                        <div class="text">{{$t("favourite_games")}}</div>
                    </button>
                    <button @click="selectedCategoryFunction(3)" :aria-label="$t('new_games')" type="button" class="category_btn mr-5" :class="selectedCategory == 3 ? 'active' : ''">
                        <Icon v-if="config.public?.IS_NEW_ICON" iconClass="icon-new m-2"></Icon>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                            <path id="Path_94623" data-name="Path 94623" d="M23.579,10.651c-.385-.284-.865-.638-.928-.873A2.91,2.91,0,0,1,23.025,8.5c.339-.778.689-1.585.3-2.255s-1.274-.779-2.125-.875a2.893,2.893,0,0,1-1.271-.3,2.9,2.9,0,0,1-.3-1.271c-.1-.851-.195-1.732-.875-2.125-.591-.343-1.467-.043-2.255.3a3.617,3.617,0,0,1-1.276.374c-.235-.063-.588-.543-.873-.928C13.858.754,13.3,0,12.5,0s-1.358.754-1.848,1.42c-.285.386-.638.866-.971.939A3.742,3.742,0,0,1,8.5,1.974a2.748,2.748,0,0,0-2.254-.3c-.682.393-.78,1.274-.876,2.126a2.914,2.914,0,0,1-.3,1.271,2.9,2.9,0,0,1-1.271.3c-.852.1-1.734.2-2.126.875s-.038,1.476.3,2.255a2.9,2.9,0,0,1,.374,1.276c-.063.235-.542.589-.928.873C.754,11.141,0,11.7,0,12.5s.754,1.359,1.421,1.849c.385.284.865.638.928.873A2.91,2.91,0,0,1,1.975,16.5c-.339.778-.689,1.585-.3,2.255s1.274.779,2.125.875a2.893,2.893,0,0,1,1.271.3,2.9,2.9,0,0,1,.3,1.271c.1.851.195,1.732.875,2.125.588.342,1.464.043,2.254-.3a3.345,3.345,0,0,1,1.276-.374c.235.063.588.543.873.928C11.142,24.246,11.7,25,12.5,25s1.358-.754,1.848-1.42c.285-.386.638-.866.971-.94a3.742,3.742,0,0,1,1.178.385c.792.343,1.667.641,2.254.3.682-.393.78-1.274.876-2.126a2.914,2.914,0,0,1,.3-1.271,2.9,2.9,0,0,1,1.271-.3c.852-.1,1.734-.195,2.126-.875s.038-1.476-.3-2.255a2.914,2.914,0,0,1-.374-1.275c.063-.235.542-.589.928-.873C24.246,13.859,25,13.3,25,12.5s-.754-1.359-1.421-1.849Zm-13.8,4.023a.544.544,0,0,1-.372.515.522.522,0,0,1-.172.028A.545.545,0,0,1,8.8,15L6.522,11.957v2.717a.543.543,0,0,1-1.087,0V10.326A.544.544,0,0,1,6.413,10L8.7,13.043V10.326a.543.543,0,1,1,1.087,0Zm3.8-2.717a.543.543,0,1,1,0,1.087h-1.63V14.13h1.63a.543.543,0,0,1,0,1.087H11.413a.544.544,0,0,1-.543-.543V10.326a.544.544,0,0,1,.543-.543h2.174a.543.543,0,1,1,0,1.087h-1.63v1.087Zm7.049-1.5-1.087,4.348a.542.542,0,0,1-.507.411h-.022a.544.544,0,0,1-.516-.372l-.57-1.713-.571,1.714a.517.517,0,0,1-.537.371.544.544,0,0,1-.507-.411l-1.087-4.348a.543.543,0,0,1,1.054-.263l.634,2.537.5-1.49a.566.566,0,0,1,1.031,0l.5,1.49.634-2.537a.544.544,0,0,1,1.056.263Z"/>
                        </svg>
                        <div class="text">{{$t("new_games")}}</div>
                    </button>
                    <button v-if="[1].includes(config.public?.TMPL_TYPE) && userStore.loggedIn" :aria-label="$t('recently_played')" @click="selectedCategoryFunction(5)" type="button" class="category_btn mr-5" :class="selectedCategory == 5 ? 'active' : ''">
                        <Icon iconClass="icon-recently-played m-2"></Icon>
                        <div class="text">{{$t("recently_played")}}</div>
                    </button>
                </div>
                <DForm novalidate>
                    <div class="search_box">
                        <div class="relative">
                            <input v-model="game_input" @input="searchBuffer()" type="text" class="search_input border_search_custom" :placeholder="$t('search_game_dot')" autocapitalize="off">
                            <Icon iconClass="icon-search search_icon"></Icon>
                            <svg v-if="game_input"  @click="game_input = ''; handleSearch()" class="clean_search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg>

                            <!-- <img v-if="game_input" class="clean_search" @click="game_input = ''; handleSearch()" src="/img/icons/close_2.svg" alt="close_2"> -->
                        </div>
                        <!-- <button v-if="config.public.ENV == 'production'" type="submit" class="search_btn rounded-r-[30px] h-[40px] px-4">{{$t("search")}}</button> -->
                    </div>
                </DForm>
            </div>
            <div class="mt-5 flex items-center slot_btn_container w-full overflow-auto light-scrollbar-h pb-[10px]" ref="providerTabList">
                <button @click="selectProviderTab(i, index)" v-for="(i, index) in gamesStore[type].list" :aria-label="index" :key="index" type="button" class="block  mr-3 relative" :class="index == selected_index_tab ? 'active' : ''">
                    <div v-if="gamesProviderList.includes(index) && jackpotGameReady" class="jackpot-card-bg rounded text-[9px] font-bold absolute top-0 left-1/2 -translate-x-1/2 text-center z-10 w-full py-0.5 uppercase">Jackpot</div>
                    <img v-else-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_vpn == 1" class="vpn_tag select-none" draggable="false" src="/img/icons/new_vpn.webp" alt="vpn_tag" :style="getVpnStyle"/>     
                    <div class="tab_btn_bg relative overflow-hidden">
                        <template v-if="config.public.MERCHANT == 'dis88'">
                            <template v-if="getMaintenanceStatus(index)">
                                <img class="maintenance-tag" draggable="false" src="/img/icons/warning.webp" alt="warning" />
                            </template>
                            <template v-else>
                                <div v-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_hot == 1" class="provider_hot_tag_2">
                                    <img class="w-[35px] select-none" draggable="false" src="/img/icons/hot_gif.gif" alt="hot_gif" />
                                </div>
                                <img v-else-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_new == 1" class="app_tag select-none" draggable="false" src="/img/icons/new_tag.webp" alt="new_tag" />
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="getMaintenanceStatus(index)">
                                <img class="maintenance-tag" draggable="false" src="/img/icons/warning.webp" alt="warning" />
                            </template>
                            <template v-else>
                                <div v-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_hot == 1" class="provider_hot_tag">
                                    <img class="w-[20px] mx-auto" :src="$resolveUrl(`{d}web_asset/hot.png`)" alt="hot" />
                                </div>
                                <img v-else-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_new == 1" class="app_tag select-none" draggable="false" src="/img/icons/new_tag.webp" alt="new_tag" />
                            </template>
                        </template>
                        <img class="w-[30px] select-none slot_btn_img" draggable="false" :src="getProviderLogo(index)" :alt="`provider_${index}`" />
                    </div>
                      <template v-if="ratioInfoDisplay">
                        <div v-for="(value, key) in providerStore.data[type]" :key="key" class="relative"> 
                            <div v-if="value.providerName.toUpperCase() == index && value.ratio" class="game-container-ratio-info-small">{{dashboardStore.data.currency}} {{value.ratio}} = 1</div>
                        </div>
                    </template>
                    
                    <div class="tab_btn_text text-center text-xs mt-2 uppercase w-[50px] truncate">{{ index }}</div>
                </button>
                
                <button v-for="i in providerListAPP" :key="`${i.providerName}_app`" @click="openAPP(i)" :aria-label="i.providerName" type="button" class="block mr-3">
                    <div class="tab_btn_bg relative overflow-hidden">
                        <img class="app_tag select-none" draggable="false" src="/img/icons/app_tag.webp" alt="app_tag" />
                        <img class="w-[30px] select-none" draggable="false" :src="getProviderLogo(i.providerName)" :alt="`provider_${i.providerName}`" />
                    </div>
                    <div class="tab_btn_text text-center text-xs mt-2 uppercase  w-[50px] truncate">{{i.providerName}}</div>
                </button>
            </div>
            <template v-if="ratioInfoDisplay">
                 <div v-for="(value, key) in providerStore.data[type]" :key="key" class="game-container-ratio-wrapper"><div v-if="value.providerName == selected_index_tab && value.ratio" class="game-container-ratio-alert"><svg class="game-container-ratio-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><circle data-name="Ellipse 1140" cx="6.5" cy="6.5" r="6.5" fill="#F55500"/><g data-name="Group 40778" transform="translate(5.372 1.527)" fill="#000"><path data-name="Path 94399" d="M.261 6.562.001.943C-.058-.318 2.312-.31 2.25.944l-.256 5.618v.456a.867.867 0 0 1-1.733 0Z" fill-rule="evenodd"/><circle data-name="Ellipse 1141" cx=".865" cy=".865" r=".865" transform="translate(.263 8.228)"/></g></svg>{{ $t('notice_this_provider_is') }} <span class="game-container-ratio-value">{{dashboardStore.data.currency}} {{value.ratio}} = 1</span></div></div>
            </template>
            <div v-if="getJackpotVal && jackpotGameReady" class="jackpot-box-content w-full md:max-w-[95%] lg:max-w-[85%] xl:max-w-[75%] mx-auto mt-10 relative">
                <div class="jackpot-box-bg">
                    <div class="w-full absolute bottom-[8%] left-1/2 -translate-x-1/2 px-2 sm:px-5 lg:px-0">
                        <div class="flex items-end justify-center gap-2">
                            <JackpotBox :target="getJackpotVal?.mini" :tick="150" textClass="top-[50%] text-[4vw] md:text-[30px] lg:text-[40px]" :boxImg="'mini_box.webp'" />
                            <JackpotBox :target="getJackpotVal?.grand" :tick="5" textClass="top-[55%] text-[4vw] md:text-[38px] lg:text-[48px]" :boxImg="'grand_box.webp'" />
                            <JackpotBox :target="getJackpotVal?.major" :tick="15" textClass="top-[50%] text-[4vw] md:text-[30px] lg:text-[40px]" :boxImg="'major_box.webp'" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="Object.keys(gamesStore[type].list).length > 0">
                <div v-if="gameList.length > 0" class="game_container" :key="gameListKey">
                    <div v-if="mainStore.loadingGame" class="loading_bg">
                        <Spinner></Spinner>
                    </div>
                    <div v-if="gameList[0]" class="game_container_main">
                        <div class="aspect_ratio_box"></div>
                        <!-- <div class="game_container_main_bg">
                            <img class="w-full h-full" :src="checkImg(gameList[0].img)" :alt="`${gameList[0].img}`" loading="lazy">
                        </div> -->
                        <div v-for="i in 1" class="game_btn placeholder" ref="gameRefs">
                            <div class="game_btn_aspect_ratio"></div>
                            <div class="game-container">
                                <img :src="$pub(`/img/logo-dark.png`)" alt="game-container-img" />
                            </div>
                            <img class="game_img" :src="checkImg(gameList[0].img)" :alt="`${gameList[0].img}`" loading="lazy">
                            <!-- <div class="provider_corner_badge">
                                <img class="provider_corner_badge_img" :src="getProviderLogoWhite(gameList[0].provider_name)" :alt="`provider_${gameList[0].provider_name}`" loading="lazy">
                            </div> -->
                            <img v-if="gameList[0].hot_game == 1" class="game_hot_icon" :src="`${config.public.STATIC_ROOT}img/icons/hot-tag.webp`" alt="hot-tag" loading="lazy">
                            <img v-else-if="gameList[0].new == 1" class="game_hot_icon" :src="`${config.public.STATIC_ROOT}img/icons/new-tag.webp`" alt="new-tag" loading="lazy">
                            <div class="game_btn_content" :class="checkFavourite(gameList[0])">
                                <div class="game_btn_section">
                                    <button @click="favouriteGame(gameList[0])" type="button" class="bg-favourite-btn text-base text-[#fff] bg-[var(--primary)] bg-oz-primary py-[5px] w-full rounded-[50px]" :aria-label="$t('favourite')">{{mainStore.userFavourite.list.find(obj => obj.game_id == gameList[0].game_id) ? $t("unfavourite") : $t("favourite")}}</button>
                                    <button @click="playGame(gameList[0])" type="button" class="mt-3 text-base bg-playnow-btn py-[5px] w-full rounded-[50px] bg-oz-game-play-btn" :aria-label="$t('play_now')">{{$t("play_now")}}</button>
                                </div>
                                <div class="game_btn_content_text">{{(gameList[0].game_lang && gameList[0].game_lang[mainStore.lang]) ? gameList[0].game_lang[mainStore.lang] : gameList[0].game_name}}</div>
                                <div class="game_btn_content_favourite" @click.stop="favouriteGame(g)">
                                    <Icon v-if="mainStore.userFavourite.list.find(obj => obj.game_id == gameList[0].game_id)" iconClass="icon-favourite"></Icon>
                                    <Icon v-else iconClass="icon-favourite inactive"></Icon>
                                </div>
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
                                </svg> -->                              
                            </div>
                        </div>
                        <div v-if="dashboardStore.maintenanceData[gameList[0].provider_id]" class="maintenance_box">
                            <div class="maintenance_text">
                                <div class="maintenance_text_1">
                                    <span v-if="dashboardStore.maintenanceData[gameList[0].provider_id].end_date != '-'">{{ $t('maintenance_note', {start_date: dashboardStore.maintenanceData[gameList[0].provider_id].start_date, end_date: dashboardStore.maintenanceData[gameList[0].provider_id].end_date})}}</span>
                                    <span v-else>{{ $t('maintenance_note_2', {start_date: dashboardStore.maintenanceData[gameList[0].provider_id].start_date})}}</span>
                                </div>
                                <div class="maintenance_text_2">[{{gameList[0].provider_name}}]</div>
                            </div>
                        </div>
                    </div>
                    <div class="game_container_top">
                        <div v-for="g in topGameList" :key="g.id" class="game_btn placeholder" ref="gameRefs" :class="dashboardStore.maintenanceData[g.provider_id] ? 'maintenance' : ''">
                            <div class="game_btn_aspect_ratio"></div>
                            <div class="game-container">
                                <img :src="$pub(`/img/logo-dark.png`)" alt="game-container-img" />
                            </div>
                            <img class="game_img" :src="checkImg(g.img)" :alt="`${g.img}`" loading="lazy">
                            <!-- <div class="provider_corner_badge">
                                <img class="provider_corner_badge_img" :src="getProviderLogoWhite(g.provider_name)" :alt="`provider_${g.provider_name}`" loading="lazy">
                            </div> -->
                            <img v-if="g.hot_game == 1" class="game_hot_icon" :src="`${config.public.STATIC_ROOT}img/icons/hot-tag.webp`" alt="hot-tag" loading="lazy">
                            <img v-else-if="g.new == 1" class="game_hot_icon" :src="`${config.public.STATIC_ROOT}img/icons/new-tag.webp`" alt="new-tag" loading="lazy">
                            <div class="game_btn_content" :class="checkFavourite(g)">
                                <div class="game_btn_section">
                                    <button @click="favouriteGame(g)" type="button" class="bg-favourite-btn text-base text-[#fff] bg-[var(--primary)] bg-oz-primary py-[5px] w-full rounded-[50px]" :aria-label="$t('favourite')">{{mainStore.userFavourite.list.find(obj => obj.game_id == g.game_id) ? $t("unfavourite") : $t("favourite")}}</button>
                                    <button @click="playGame(g)" type="button" class="mt-3 text-base bg-playnow-btn py-[5px] w-full rounded-[50px] bg-oz-game-play-btn" :aria-label="$t('play_now')">{{$t("play_now")}}</button>
                                </div>
                                <div class="game_btn_content_text">{{(g.game_lang && g.game_lang[mainStore.lang]) ? g.game_lang[mainStore.lang] : g.game_name}}</div>
                                <div class="game_btn_content_favourite" @click.stop="favouriteGame(g)">
                                    <Icon v-if="mainStore.userFavourite.list.find(obj => obj.game_id == g.game_id)" iconClass="icon-favourite"></Icon>
                                    <Icon v-else iconClass="icon-favourite inactive"></Icon>
                                </div>
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
                                </svg> -->
                            </div>
                            <div v-if="dashboardStore.maintenanceData[g.provider_id]" class="maintenance_box">
                                <div class="maintenance_text">
                                    <div class="maintenance_text_1">
                                        <span v-if="dashboardStore.maintenanceData[g.provider_id].end_date != '-'">{{ $t('maintenance_note', {start_date: dashboardStore.maintenanceData[g.provider_id].start_date, end_date: dashboardStore.maintenanceData[g.provider_id].end_date})}}</span>
                                        <span v-else>{{ $t('maintenance_note_2', {start_date: dashboardStore.maintenanceData[g.provider_id].start_date})}}</span>
                                    </div>
                                    <div class="maintenance_text_2">[{{g.provider_name}}]</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="game_container_bottom">
                        <div v-for="g in bottomGameList" :key="g.id" class="game_btn placeholder" ref="gameRefs" :class="dashboardStore.maintenanceData[g.provider_id] ? 'maintenance' : ''">
                            <div class="game_btn_aspect_ratio"></div>
                            <div class="game-container">
                                <img :src="$pub(`/img/logo-dark.png`)" alt="game-container-img" />
                            </div>
                            <img class="w-full h-full game_img" :src="checkImg(g.img)" :alt="`${g.img}`" loading="lazy">
                            <!-- <div class="provider_corner_badge">
                                <img class="provider_corner_badge_img" :src="getProviderLogoWhite(g.provider_name)" :alt="`provider_${g.provider_name}`" loading="lazy">
                            </div> -->
                            <img v-if="g.hot_game == 1" class="game_hot_icon" :src="`${config.public.STATIC_ROOT}img/icons/hot-tag.webp`" alt="hot-tag" loading="lazy">
                            <img v-else-if="g.new == 1" class="game_hot_icon" :src="`${config.public.STATIC_ROOT}img/icons/new-tag.webp`" alt="new-tag" loading="lazy">
                            <div class="game_btn_content" :class="checkFavourite(g)">
                                <div class="game_btn_section">
                                    <button @click="favouriteGame(g)" type="button" class="bg-favourite-btn text-base text-[#fff] bg-[var(--primary)] bg-oz-primary py-[5px] w-full rounded-[50px]" :aria-label="$t('favourite')">{{mainStore.userFavourite.list.find(obj => obj.game_id == g.game_id) ? $t("unfavourite") : $t("favourite")}}</button>
                                    <button @click="playGame(g)" type="button" class="mt-3 text-base bg-playnow-btn py-[5px] w-full rounded-[50px] bg-oz-game-play-btn" :aria-label="$t('play_now')">{{$t("play_now")}}</button>
                                </div>
                                <div class="game_btn_content_text">{{(g.game_lang && g.game_lang[mainStore.lang]) ? g.game_lang[mainStore.lang] : g.game_name}}</div>
                                <div class="game_btn_content_favourite" @click.stop="favouriteGame(g)">
                                    <Icon v-if="mainStore.userFavourite.list.find(obj => obj.game_id == g.game_id)" iconClass="icon-favourite"></Icon>
                                    <Icon v-else iconClass="icon-favourite inactive"></Icon>
                                </div>

                                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
                                </svg> -->
                               
                            </div>
                            <div v-if="dashboardStore.maintenanceData[g.provider_id]" class="maintenance_box">
                                <div class="maintenance_text">
                                    <div class="maintenance_text_1">{{ $t('maintenance_note', {start_date: dashboardStore.maintenanceData[g.provider_id].start_date, end_date: dashboardStore.maintenanceData[g.provider_id].end_date})}}</div>
                                    <div class="maintenance_text_2">[{{g.provider_name}}]</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5 w-full">
                        <PaginationGame :totalPage="totalPage" :value="currentPage" @change="paginate"></PaginationGame>
                    </div>
                </div>
                <div v-else class="text-center mt-[20px] text-sm no_game_found_text_color">{{$t("no_games_found")}}</div>
            </div>
        </div>
        <div v-else>
            <div class="mt-5 flex items-center" :class="showCategoryBtn ? 'justify-between' : 'justify-end'">
                <div v-if="showCategoryBtn" class="inline-flex items-center border-[1px] cat-btn-container rounded-[30px] px-[20px] py-[10px]">
                    <div class="category_btn skeleton w-[400px] h-[24px]" aria-hidden="true"></div>
                </div>
                <div class="skeleton w-[279px] h-[40px]"></div>
            </div>
            <div class="mt-5 flex items-center w-full overflow-auto light-scrollbar-h pb-[10px]">
                <div class="skeleton w-full h-[70px]"></div>
            </div>
            <div class="game_container">
                <div class="game_container_main">
                    <div class="skeleton w-full h-full"></div>
                </div>
                <div class="game_container_top">
                    <div v-for="i in 10" :key="i" class="game_btn">
                        <div class="game_btn_aspect_ratio skeleton"></div>
                    </div>
                </div>
                <div class="game_container_bottom">
                    <div v-for="i in 35" :key="i" class="game_btn">
                        <div class="game_btn_aspect_ratio skeleton"></div>
                    </div>
                </div>
            </div>
        </div>

        <AppModal :show="appModal" :appModalData="appModalData" @close="appModal = false"></AppModal>

    </div>
</template>

<script setup>
import { getVersionedJSON } from '~/assets/js/cache'

const props = defineProps({
    type: String
});
const route = useRoute();
const config = useRuntimeConfig();
const localePath = useLocalePath();
const router = useRouter();
const dashboardStore = useDashboardStore();
const gamesStore = useGamesStore();
const mainStore = useMainStore();
const userStore = useUserStore();
const { $api, $toast, $setMeta, $pub, $resolveUrl } = useNuxtApp();
const providerStore = useProviderStore();
const { screenHeight, screenWidth } = useScreenHeight();

const showCategoryBtn = computed(() => {
    if (['jackpot','crazygaming'].includes(props.type)) {
        return false
    }
    return true
})

const gameRefs = ref([])
const selectedCategory = ref(1);
onMounted(() => {
    const category = window.localStorage.getItem('category');
    window.localStorage.removeItem("category")
    window.localStorage.removeItem("homeProvider")
    if (category) {
        selectedCategory.value = category;
    }
})

const selectedCategoryFunction = (e) => {
    selectedCategory.value = e;
    game_input.value = "";
    searchTerm.value = "";
    currentPage.value = 1;
}

const game_input = ref("");

let bufferTimer = null
const searchBuffer = () => {
    if (bufferTimer) {
        clearTimeout(bufferTimer)
    }
    bufferTimer = setTimeout(() => {
        handleSearch()
        clearTimeout(bufferTimer)
        bufferTimer = null
    }, 300)
}

onBeforeUnmount(() => {
    clearTimeout(bufferTimer)
    bufferTimer = null
})

const searchTerm = ref('')
const handleSearch = async () => {
    searchTerm.value = game_input.value
}

const wait = (miliseconds) => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve()
        }, miliseconds)
    })
}


const providerTabList = ref();
const selected_index_tab = ref("ALL");
const selectProviderTab = (e, name) => {
    if (name == selected_index_tab.value) {
        return;
    }
    game_input.value = "";
    searchTerm.value = "";
    currentPage.value = 1;
    selected_index_tab.value = name;
    route.params.provider = name;
    history.state.current = localePath(`/${props.type}/${name}`);
    history.pushState(history.state, "", localePath(`/${props.type}/${name}`));
    $setMeta();
}

const currentPage = ref(1);
const paginate = (e) => {
    currentPage.value = e;
}

const gameListKey = ref(1)
const totalPage = ref(1)
function buildPagination(array, page_size, page_number) {
    let curr_page_number = page_number;
    
    if(localStorage.getItem('lastgame')) {
        let game_hash = localStorage.getItem('lastgame')
        let game_index = array.map(e => e.game_id).indexOf(game_hash)
        if (game_index >= 0) {
            curr_page_number = Math.ceil((game_index + 1) / page_size)
            currentPage.value = curr_page_number;
        }
    }

    totalPage.value = Math.ceil(array.length / page_size);
    gameListKey.value++
    return array.slice((curr_page_number - 1) * page_size, curr_page_number * page_size);
}

watch(gameListKey, (ko, kn) => {
    if (ko != kn) {
        gameRefs.value = [];
    }
})

watchEffect(() => {
	if (gameRefs.value.length > 0) {
        nextTick(() => {
            if(localStorage.getItem('lastgame')) {
                let game_hash = localStorage.getItem('lastgame')
                window.localStorage.removeItem("lastgame")
                let game_ref_index = gameList.value.findIndex(e => e.game_id == game_hash)
                if (game_ref_index >= 0 && gameRefs.value[game_ref_index]) {
                    setTimeout(() => {
                        const element = gameRefs.value[game_ref_index]
                        const elementPosition = element.getBoundingClientRect().top;
                        const offsetPosition = elementPosition - 50 - (screenWidth.value >= 1024 ? 90 : 50);
                        window.scrollBy({
                            top: offsetPosition,
                            behavior: "smooth"
                        });
                    }, 1000)
                }
            }
        })
    }
}, {
	flush: 'post'
})

const checkImg = (e) => {
    if (e) {
        if (e.includes('https')) {
            return e;
        } else {
            return $resolveUrl(`{m}frontend/web/${e}`);
        }
    } else {
        return $pub(`/img/logo.png`);
    }
}

const getProviderLogo = (p) => {
	if (p) {
		return $resolveUrl(`{d}game/provider${config.public.GAME_PROVIDER_LOGO}/${p.toUpperCase()}.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const getProviderLogoWhite = (p) => {
    if (p) {
        return $resolveUrl(`{d}game/provider_name/${(p.toUpperCase())}_white.webp`);
    } else {
        return $pub('/img/logo.png');
    }
}

const playGame = (e) => {
    var getProvider = providerStore.data[props.type].find(obj => obj.id == e.provider_id);
    if (getProvider && getProvider.mobile_status && getProvider.mobile_status == '1') {
        openAPP(getProvider)
        return
    }

    var game = {
        provider_name: e.provider_name,
        currency: dashboardStore.data.currency,
        provider_id: e.provider_id,
        game_id: e.game_id,
        maintenance: dashboardStore.maintenanceData[e.provider_id],
        category: selectedCategory.value
    }
    gamesStore.playGame(game);
}

const checkFavourite = (e) => {
    var checkGameFavourite = mainStore.userFavourite.list.find(obj => obj == e.game_id);
    if (checkGameFavourite) {
        return "favourite"
    } else {
        return ""
    }
}

const favouriteGame = async(e) => {
	if (userStore.loggedIn) {
        var checkGameFavourite = mainStore.userFavourite.list.find(obj => obj.game_id == e.game_id);
        if (checkGameFavourite) {
            mainStore.userFavourite.list = mainStore.userFavourite.list.filter(obj => obj.game_id !== e.game_id);
            gamesStore.toggleFavourite({game_id: e.game_id})

        } else {
            mainStore.userFavourite.list.push({game_id: e.game_id});
            gamesStore.toggleFavourite({game_id: e.game_id})
        }
	} else {
		mainStore.loginModal = true;
	}
}

const pos = ref({ top: 0, left: 0, x: 0, y: 0 });
const mouseDownHandler = (e) => {
    providerTabList.value.style.userSelect = 'none';
    pos.value = {
        // The current scroll
        left: providerTabList.value.scrollLeft,
        top: providerTabList.value.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
    };
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
}
const mouseMoveHandler = (e) => {
    // How far the mouse has been moved
    const dx = e.clientX - pos.value.x;
    const dy = e.clientY - pos.value.y;

    // Scroll the element
    providerTabList.value.scrollTop = pos.value.top - dy;
    providerTabList.value.scrollLeft = pos.value.left - dx;
};
const mouseUpHandler = (e) => {
    providerTabList.value.style.removeProperty('user-select');
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
};
watch(providerTabList, (el) => {
    if (el) {
        providerTabList.value.addEventListener('mousedown', mouseDownHandler);
    }
})

const gameList = computed(() => {
    if (!providerStore.ready || !gamesStore[props.type].ready) {
        return []
    }
    if (!gamesStore[props.type].list[selected_index_tab.value]) {
        return []
    }
    let allGames = []

    if (selectedCategory.value == 1) { // all games
        allGames = gamesStore[props.type].list[selected_index_tab.value]
    } else if (selectedCategory.value == 2) { // hot games
        allGames = gamesStore[props.type].list[selected_index_tab.value].filter(game => game.hot_game == 1)
    } else if (selectedCategory.value == 3) { // new games
        allGames = gamesStore[props.type].list[selected_index_tab.value].filter(game => game.new == "1")
    } else if (selectedCategory.value == 4) { // fav games
        const userFavourite = mainStore.userFavourite.list
        if(userFavourite.length > 0) {
            const recentGameIds = new Set(userFavourite.map(g => Number(g.game_id)))

            allGames = gamesStore[props.type].list[selected_index_tab.value].map((game) => {
                    return {
                        ...game,
                        recent: recentGameIds.has(game.game_id) ? 1 : 0
                    }
                }
            ).filter(game => game.recent == 1)
        }else {
            return allGames = []
        }
    } else if (selectedCategory.value == 5) { // recent games
        const recentGames = mainStore.recentGames.list
        if(recentGames.length > 0) {
            const recentGameIds = new Set(recentGames.map(g => Number(g.game_id)))

            allGames = gamesStore[props.type].list[selected_index_tab.value].map((game) => {
                    return {
                        ...game,
                        recent: recentGameIds.has(game.game_id) ? 1 : 0
                    }
                }
            ).filter(game => game.recent == 1)
        }else {
            return allGames = []
        }
    } else {
        return []
    }

    // filter by search term
    if (searchTerm.value) {
        allGames = allGames.filter(game => {
            let gameNameUpperCase = (game.game_lang && game.game_lang[mainStore.lang]) ? game.game_lang[mainStore.lang].toUpperCase() : game.game_name.toUpperCase()
            let searchTermUpperCase = searchTerm.value.toUpperCase()
            return gameNameUpperCase.indexOf(searchTermUpperCase) > -1
        })
    }
    // select the game for current page
    return buildPagination(allGames, 46, currentPage.value)
})

// Watcher for route.params.provider to update selected_index_tab
watch(
  [() => route.params.provider, () => gamesStore[props.type].list],
  ([newProvider, list]) => {
    // Only proceed if list is a non-empty object
    if (!list || Object.keys(list).length === 0) return;

    if (newProvider) {
      selected_index_tab.value = newProvider.toUpperCase();
    } else {
      selected_index_tab.value = Object.keys(list)[0];
    }
  },
  { immediate: true }
);

const topGameList = computed(() => {
    return gameList.value.slice(1, 11)
})

const ratioInfoDisplay = computed(() => {
  const merchant = config.public.MERCHANT;
  const currency = dashboardStore.data?.currency;  
  return ((merchant === 'jw8' && currency === 'IDR') || (merchant === 'champ191' && ['IDR', 'VND'].includes(currency))
  );
});

const bottomGameList = computed(() => {
    return gameList.value.slice(11)
})


// APP LIST
const providerListAPP = computed(()=> {
    if (props.type == "egames"){
        return []
    }
    if (providerStore.ready && providerStore.data && providerStore.data[props.type]) {
        var totalGame = [];
        var arrayAPP = providerStore.data[props.type].filter(obj => obj.mobile_status == '1');
        for (let i = 0; i < arrayAPP.length; i++) {
            totalGame.push(arrayAPP[i]);
        }
        return totalGame; 
    }
    return []
})

const appModal = ref(false);
const appModalData = ref({
    provider: "",
    provider_name: "-",
    username: "-",
    password: "-",
    url: "-",
    provider_data: null,
});

const openAPP = async (e) => {
    if (!userStore.loggedIn) {
        mainStore.loginModal = true;
        return
    }
    if (mainStore.loadingGame == true) {
        return;
    }
    mainStore.loadingGame = true;
    const res = await $api('mobile/mobile-login', {
        provider_id: e.id,
        currency: dashboardStore.data.currency,
    });
    if (!res.status) {
        mainStore.loadingGame = false;
        $toast(false, res.msg)
        return
    }
    appModalData.value = {
        provider: e.providerName.toUpperCase(),
        provider_name: e.display_name,
        username: res.data.username,
        password: res.data.password,
        url: res.data.url,
        play_link: res.data.play_link,
        provider_data: e,
    }

    appModal.value = true;
    mainStore.loadingGame = false;
}

const getMaintenanceStatus = (p) => {
    if (providerStore.data[props.type]) {
        var getProviderData = providerStore.data[props.type].find(obj => obj.providerName == p);
        if (getProviderData && getProviderData.id && dashboardStore.maintenanceData && dashboardStore.maintenanceData[getProviderData.id]) {
            return true;
        }
        return false;
    }
    return false;
}

const getVpnStyle = computed(() => {    
    return {
         background: mainStore.vpn_tag_color,
         padding:'3px'
    }
})

const getJackpotList = ref([]);
const getJackpotListData = ref([]);
const getJackpotVal = ref(null);

watch([() => selected_index_tab.value, () => getJackpotListData.value], ([tab, list]) => {
  if (!list || !Array.isArray(list)) return
  getJackpotVal.value = list.find(p => p.provider_name === tab)
})

const gamesProviderList = computed(() => {
    const list = gamesStore[props.type]?.list
    if (!getJackpotListData.value?.length) return []

    const jackpotProviders = getJackpotListData.value.map(p => p.provider_name)
    return Object.keys(list).filter(key => jackpotProviders.includes(key))
})

const jackpotGameReady = computed(() => {
    if (props.type == 'jackpot' && gamesStore.jackpot.ready && !gamesStore.jackpot.noFound && !gamesStore.jackpot.getting && gamesStore.jackpot.list) {
        return true
    }
    return false
})

watch(() => jackpotGameReady.value, async (isTrue) => {
    if (isTrue) {
        getJackpotList.value = await getVersionedJSON(`{m}backend/{env}/game/{cur}/jackpot_prize_list.json.gz`, 'jackpot_prize_list')
        if(getJackpotList.value && getJackpotList.value.data) {
            getJackpotListData.value = getJackpotList.value.data
        }
        else {
            getJackpotListData.value = []
        }
    }
    else {
        getJackpotListData.value = []
    }
}, { immediate : true })
</script>

<style scoped>
.jackpot-box-bg {
    background-image: url('/img/jackpot/jackpot_bg.webp');
    aspect-ratio: 500 / 200;
    background-position: center;
    background-size: cover;
}

.jackpot-card-bg {
    background: linear-gradient(180deg, #FFEB50, #CC8719, #B45A00);
    color: #030303;
}

.category_btn {
    display: flex;
    align-items: center;
    justify-content: center;
}

.category_btn svg {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

.category_btn i {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

.category_btn svg path {
    fill: var(--category-btn);
    transition: all 0.3s;
}

.category_btn i::before {
    color: var(--category-btn);
    transition: all 0.3s;
    font-size: 20px;
}
.category_btn .text {
    font-weight: 400;
    font-size: 16px;
    color: var(--category-btn);
    transition: all 0.3s;
}

.category_btn.active svg path {
    fill: var(--category-svg-active);
}

.category_btn.active i::before {
    color: var(--category-svg-active);
}
.category_btn.active .text {
    color: var(--category-btn-active);
}
.clean_search {
    width: 20px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
}

.provider_hot_tag {
    position: absolute;
    top: 0px;
    left: 0px;
}

.provider_hot_tag_2 {
    position: absolute;
    top: -10px;
    left: -5px;
}

.game_hot_icon {
    left: auto;
    right: 10px;
}

.border_search_custom{
    border-radius: 50px !important;
}

.maintenance-tag {
    width: 20px;
    position: absolute;
    top: 5px;
    left: 5px;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}
.vpn_tag {
    width: 25px;
	position: absolute;
	top: 0px;
	right: 0px;
    z-index:10
}

.game-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.game-container img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 65%;
    height: auto;
    filter: grayscale(1);
    pointer-events: none;
}

.provider_corner_badge {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 60px;
    height: 28px;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000000;
    border-bottom-right-radius: 8px;
}

.provider_corner_badge_img {
    width: auto;
    max-width: 100%;
    height: 30px;
    display: block;
    object-fit: contain;
}

</style>
